import React, { useCallback } from 'react';
import { closeOutline } from 'ionicons/icons';
import { IonModal, IonButton, IonIcon } from '@ionic/react';

import '../../../styles/fight/takerProcess/TakerError.scss';

const TakerError = ({ isOpen, onClose, setIsOpen, msg, isListenerRequired, buttonText, onButtonClick }) => {
  const onModalClose = useCallback(() => {
    setIsOpen(false);
    onClose();
  }, [setIsOpen, onClose]);

  // Added this because onClick wasn't working when placed within an IonNav for some reason
  const addCloseListener = useCallback(
    elem => {
      if (!isListenerRequired || !elem) {
        return () => {};
      }

      elem.addEventListener('click', onModalClose);

      return () => {
        elem.removeEventListener('click', onModalClose);
      };
    },
    [isListenerRequired, onModalClose],
  );

  if (!isOpen) {
    return null;
  }

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onModalClose} cssClass='transparent-modal' backdropDismiss>
      <div className='error-modal-wrapper'>
        <IonButton className='error-close-button' size='small' onClick={onModalClose} ref={addCloseListener}>
          <IonIcon icon={closeOutline} slot='icon-only' />
        </IonButton>
        <h2 className='error-message'>{msg}</h2>
        {onButtonClick && (
          <IonButton className='error-action-button' onClick={onButtonClick}>
            {buttonText}
          </IonButton>
        )}
      </div>
    </IonModal>
  );
};

export default TakerError;
